import React from 'react'

const CA500 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Yokogawa</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Handheld Instruments </span>
                        <i class="fa fa-angle-right"></i>
                        <span>CA500 Series Multi-Function Process Calibrator</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/ca5.png' width={400} style={{ marginLeft: "90px" }}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>CA500 Series Multi-Function
                            Process Calibrator:</h2>
                        <p class="mbot25">
                            The CA500 and CA550 are high-performance, multi-function calibrators designed
                            for use in multiple applications. Featuring useful functions for field work, these
                            multi-function calibrators help you calibrate field instruments with improved source and measurement accuracy.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CA500
